import { PAYMENT_BASE_URL } from "../../../constants";

/** PAYMENT_BASE_URL is `…/payments/`; app props live under its `v2/app-props`. */
export const APP_PROPS_URL = `${PAYMENT_BASE_URL}v2/app-props`;

/**
 * App prop names the admin reads. Names are fixed once created (the backend
 * can't rename a prop), so they're safe to key on.
 */
export const APP_PROP_NAMES = {
  /** Comma-separated organization codes eligible for auto-cashout. */
  AUTO_CASHOUT_INCLUDE_ORG_CODES: "AUTO_CASHOUT_INCLUDE_ORG_CODES",
  /**
   * "true"/"false": switches the backend auto-cashout scheduler. Backend-only;
   * not an eligibility rule in the admin.
   */
  AUTO_CASHOUT_RUN_SCHEDULED: "AUTO_CASHOUT_RUN_SCHEDULED",
} as const;

export type AppPropName = (typeof APP_PROP_NAMES)[keyof typeof APP_PROP_NAMES];
